<template>
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="29.2471"
      y="15.2474"
      width="14.9381"
      height="83.7835"
      fill="#E0E5FF"
    />
    <rect
      x="28"
      y="14"
      width="59"
      height="86.2784"
      rx="3"
      stroke="#4D4E58"
      stroke-width="4"
    />
    <rect
      x="35"
      y="32"
      width="45.4639"
      height="5"
      rx="2"
      fill="#4D4E58"
    />
    <rect
      x="35"
      y="45"
      width="45.4639"
      height="5"
      rx="2"
      fill="#4D4E58"
    />
    <rect
      x="40"
      y="58"
      width="34.4227"
      height="5"
      rx="2"
      fill="#4D4E58"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M62.1306 71.0145C62.7943 70.9708 63.4581 71.0349 63.8805 71.089C64.3568 71.15 64.8191 71.4116 65.0344 71.9312C65.2059 72.3449 65.1448 72.76 65.0906 73.0033C65.0011 73.4051 64.7898 73.8717 64.6733 74.1291C64.6485 74.184 64.6279 74.2293 64.6138 74.2625C64.0352 75.6215 63.1393 76.5593 62.0906 77.1443C62.1479 77.1691 62.2 77.1815 62.2459 77.1859C62.6142 77.2213 62.881 77.1769 63.1163 77.0815C63.3643 76.9809 63.6349 76.8002 63.9771 76.4802C64.2574 76.2182 64.6091 75.9274 64.9318 75.6606C65.129 75.4976 65.3153 75.3435 65.4678 75.2105C65.6041 75.0917 65.7325 74.9746 65.8524 74.8577C65.9042 74.6105 65.9819 74.3612 66.0882 74.1116C66.3858 73.4124 66.8779 72.7801 67.2631 72.3232C67.3054 72.273 67.4096 72.1586 67.4909 72.0713C67.534 72.0251 67.5814 71.9749 67.621 71.9349C67.638 71.9177 67.6673 71.8883 67.6989 71.86L67.7 71.8591C67.71 71.85 67.7562 71.8085 67.818 71.7672C67.8181 71.7672 67.8182 71.7671 67.8185 71.767C67.8271 71.7608 67.9637 71.6645 68.1604 71.623C68.2554 71.603 68.5904 71.5464 68.9217 71.779C69.2923 72.0391 69.3365 72.4239 69.3365 72.5769C69.3365 73.1728 69.0261 73.7423 68.8223 74.0841C68.7049 74.2808 68.5805 74.468 68.4765 74.6232C68.4653 74.64 68.4544 74.6562 68.4438 74.672C68.3495 74.8127 68.282 74.9133 68.2329 74.9949C68.0785 75.252 67.9052 75.4884 67.7217 75.7071C67.7358 76.1432 67.8977 76.5757 68.1842 76.9819C68.4285 77.3283 68.6648 77.4324 68.9353 77.4736C69.2586 77.5228 69.6131 77.4823 70.142 77.422C70.1962 77.4159 70.2521 77.4095 70.3101 77.403C71.435 77.2765 72.0356 77.0991 72.577 76.3645C72.7119 76.1815 72.8735 75.9829 73.0262 75.7955C73.0429 75.775 73.0595 75.7546 73.076 75.7343C73.2501 75.5203 73.4196 75.3098 73.5753 75.0962C73.9053 74.6435 74.0818 74.2957 74.1211 74.0465C74.1962 73.5708 74.5492 73.3505 74.6985 73.278C74.8576 73.2008 75.0086 73.1749 75.0902 73.1637C75.2668 73.1394 75.4582 73.1428 75.6146 73.1507C75.9444 73.1673 76.3592 73.2186 76.7521 73.2737C77.0273 73.3122 77.3133 73.3558 77.5706 73.3951C77.6835 73.4123 77.7908 73.4286 77.8893 73.4434C78.0551 73.4682 78.1955 73.4883 78.3057 73.5021C78.3936 73.5131 78.4389 73.517 78.4544 73.5183C78.4613 73.5189 78.4624 73.519 78.4588 73.519C78.9968 73.519 79.433 73.9551 79.433 74.4932C79.433 75.0312 78.9968 75.4674 78.4588 75.4674C78.253 75.4674 77.8962 75.4145 77.6011 75.3704C77.4918 75.354 77.3783 75.3367 77.262 75.319C77.0101 75.2806 76.7451 75.2402 76.4817 75.2032C76.2357 75.1688 76.0088 75.14 75.8156 75.1205C75.6318 75.5468 75.3787 75.93 75.1498 76.2439C74.9605 76.5036 74.7616 76.7498 74.5875 76.9639C74.5721 76.9828 74.557 77.0014 74.5421 77.0196C74.3815 77.217 74.2507 77.3776 74.1456 77.5203C73.1044 78.9333 71.7957 79.1967 70.5278 79.3392C70.4719 79.3455 70.4133 79.3524 70.3522 79.3597C69.8722 79.4165 69.2421 79.4911 68.6423 79.3999C67.8803 79.2839 67.1605 78.9112 66.5918 78.1048C66.3991 77.8314 66.2324 77.5359 66.1005 77.2235C66.0932 77.2294 66.0859 77.2354 66.0787 77.2414C65.8109 77.461 65.5681 77.6602 65.3078 77.9035C64.8678 78.3148 64.3977 78.6644 63.8486 78.8871C63.2867 79.115 62.6997 79.1869 62.0596 79.1254C61.2229 79.0451 60.5813 78.5548 60.1409 77.9876C60.1029 77.9387 60.066 77.8888 60.0302 77.8379C59.6814 77.891 59.3279 77.9166 58.9742 77.9166C58.4362 77.9166 58 77.4804 58 76.9424C58 76.4043 58.4362 75.9682 58.9742 75.9682C59.0603 75.9682 59.1458 75.9662 59.2308 75.9622C59.0725 75.259 59.0301 74.5019 59.1367 73.7947C59.2439 73.0839 59.5156 72.3414 60.0637 71.7888C60.6511 71.1966 61.5259 71.0544 62.1306 71.0145ZM61.1152 75.4577C61.8311 75.063 62.4266 74.4257 62.8211 73.4993C62.8522 73.4262 62.8881 73.3461 62.9213 73.2722C62.9259 73.2621 62.9303 73.2522 62.9347 73.2423C62.9734 73.1562 63.0105 73.0729 63.0456 72.9895C63.0491 72.9811 63.0525 72.9729 63.0559 72.9648C62.7982 72.9476 62.5223 72.9414 62.2587 72.9588C61.7211 72.9942 61.4947 73.1129 61.4471 73.1609C61.2854 73.324 61.1326 73.626 61.0634 74.0852C61.0002 74.5039 61.0181 74.9865 61.1152 75.4577Z"
      fill="#7B90FF"
    />
    <circle
      cx="90.0003"
      cy="89.9997"
      r="16.6667"
      transform="rotate(-180 90.0003 89.9997)"
      fill="#7B90FF"
    />
    <path
      d="M81.667 88.1609L87.8575 95L98.3337 83.3333"
      stroke="white"
      stroke-width="4"
    />
  </svg>
</template>
